const FORM_URLS: Record<string, string> = {
  '星辰影院联系表单': 'https://readdy.ai/api/form/d9mtersit35ii3jdllp0',
};

export async function get_form_url(formName: string): Promise<string | null> {
  return FORM_URLS[formName] || null;
}